module.exports = {
	"id": "MQ",
	"name": "Martinique",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.018615,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.006205,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.01241,
			"23": 0.006205,
			"24": 0.006205,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.02482,
			"29": null,
			"30": null,
			"31": 0.02482,
			"32": 0.17374,
			"33": 0.03723,
			"34": 0.04964,
			"35": 0.02482,
			"36": 0.031025,
			"37": 0.01241,
			"38": 0.02482,
			"39": 0.018615,
			"40": 0.02482,
			"41": 0.006205,
			"42": 0.018615,
			"43": 0.06205,
			"44": 0.031025,
			"45": 0.08687,
			"46": 0.03723,
			"47": 0.167535,
			"48": 0.055845,
			"49": 1.14172,
			"50": 0.08687,
			"51": 0.403325,
			"52": 0.366095,
			"53": 22.67307,
			"54": 6.831705,
			"55": 0.09928,
			"56": 0.01241,
			"57": null
		},
		"firefox": {
			"2": 0.006205,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.006205,
			"17": null,
			"18": 0.006205,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.006205,
			"25": null,
			"26": 0.006205,
			"27": 0.018615,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.01241,
			"32": 0.01241,
			"33": null,
			"34": null,
			"35": 0.006205,
			"36": 0.018615,
			"37": 0.006205,
			"38": 0.03723,
			"39": 0.018615,
			"40": 0.006205,
			"41": 0.031025,
			"42": 0.02482,
			"43": 0.093075,
			"44": 0.03723,
			"45": 0.192355,
			"46": 0.043435,
			"47": 0.564655,
			"48": 0.8687,
			"49": 6.86273,
			"50": 0.1241,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.031025
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.018615,
			"37": 0.01241,
			"38": 0.018615,
			"39": 0.01241,
			"40": 0.403325,
			"41": 0.06205,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.02482
		},
		"safari": {
			"0": null,
			"4": 0.018615,
			"5": 0.043435,
			"6": null,
			"7": 0.02482,
			"8": 0.22338,
			"9": 0.22338,
			"10": 2.09729,
			"3.1": null,
			"3.2": null,
			"5.1": 0.229585,
			"6.1": 0.093075,
			"7.1": null,
			"9.1": 1.644325
		},
		"ios_saf": {
			"8": 0,
			"10": 3.62676237302,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0977370493339,
			"8.1-8.4": 0.180565057244,
			"9.0-9.2": 0.0861411282265,
			"9.3": 1.31420439217
		},
		"android": {
			"3": 0,
			"4": 0.0435199224806,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00543999031008,
			"4.1": 0.156982577519,
			"4.2-4.3": 0.392456443798,
			"4.4": 0.899929825581,
			"4.4.3-4.4.4": 0.90770124031
		},
		"ie": {
			"6": null,
			"7": 0.037351007584,
			"8": 0.161854366197,
			"9": 0.149404030336,
			"10": 0.348609404117,
			"11": 5.04861119177,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0274798900596,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000763330279432
		},
		"edge": {
			"12": 0.291635,
			"13": 1.048645,
			"14": 2.82948
		},
		"ie_mob": {
			"10": 0.0613614084507,
			"11": 0.249828591549
		},
		"bb": {
			"7": 0.00664125,
			"10": null
		},
		"samsung": {
			"0": 5.11566
		},
		"and_uc": {
			"0": 0.1518
		},
		"op_mini": {
			"0": 0.370231779661
		},
		"and_chr": {
			"0": 27.77297
		},
		"and_ff": {
			"0": 0.018975
		}
	},
	"total": 98.16982625
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MQ.json
 ** module id = 594
 ** module chunks = 0
 **/